import { render, staticRenderFns } from "./ModifyCappedPackageModal.vue?vue&type=template&id=328f2c46&"
import script from "./ModifyCappedPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyCappedPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports